import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'fury-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
})

export class DeleteDialogComponent {

  public id: string = '';
  public title: string = 'Selectie verwijderen?';
  public text: string = 'Weet u zeker dat u deze selectie wilt verwijderen?';

  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    if (data) {
      if (data.title) {
        this.title = data.title;
      }

      if (data.text) {
        this.text = data.text;
      }
    }
  }
}
